import React, { useState } from 'react';
import { openWhatsApp, buildWelcomeHeader, WHATSAPP_PHONE, openDialer } from '../../Hooks/whatsapp';
import './Header.css';

const Header = ({ onNavigate, currentPage }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleLogoClick = () => {
    onNavigate('home');
    setIsDrawerOpen(false);
  };

  const handleNavClick = (page) => {
    onNavigate(page);
    setIsDrawerOpen(false);
  };

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <header className={`header ${isDrawerOpen ? 'drawer-open' : ''}`}>
      <div className="header-container">
        {/* Logo Section */}
        <div className="logo-section">
          <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
            <div className="logo-icon">🎈</div>
            <div className="logo-text">
              <h1>Wonder Eventzz</h1>
              <p>Celebrate life!</p>
            </div>
          </div>
        </div>

        {/* Hamburger Menu Button */}
        <button 
          className={`hamburger-menu ${isDrawerOpen ? 'active' : ''}`}
          onClick={toggleDrawer}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Navigation */}
        <nav className={`main-nav ${isDrawerOpen ? 'mobile-open' : ''}`}>
          {/* Close Button - Mobile Only */}
          <button 
            className="drawer-close-btn"
            onClick={() => setIsDrawerOpen(false)}
            aria-label="Close menu"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          
          {/* Wonder Events Logo in Middle - Mobile Only */}
          <div className="drawer-logo">
            <div className="logo-icon">🎈</div>
            <div className="logo-text">
              <h2>Wonder Eventzz</h2>
              <p>Celebrate life!</p>
            </div>
          </div>

          {/* Navigation Buttons */}
          <div className="drawer-nav-buttons">
            <button 
              className={`nav-button ${currentPage === 'home' ? 'active' : ''}`}
              onClick={() => handleNavClick('home')}
            >
              Home
            </button>
            <button 
              className={`nav-button ${currentPage === 'about' ? 'active' : ''}`}
              onClick={() => handleNavClick('about')}
            >
              About Us
            </button>
            <button 
              className={`nav-button ${currentPage === 'contact' ? 'active' : ''}`}
              onClick={() => handleNavClick('contact')}
            >
              Contact Us
            </button>
          </div>

          {/* Social Media & Contact - Mobile Only */}
          <div className="drawer-social-contact">
            <div className="drawer-social-icons">
<div className="drawer-social-icons-container">
              <a 
                href="https://www.instagram.com/wonder_event55?igsh=NHljZDkyZ3dteXFv"
                className="drawer-social-link instagram" 
                aria-label="Instagram" 
                title="Instagram"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setIsDrawerOpen(false)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                  <path d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm0 2a3 3 0 00-3 3v10a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H7zm5 3a5 5 0 110 10 5 5 0 010-10zm0 2.2a2.8 2.8 0 100 5.6 2.8 2.8 0 000-5.6zM18.5 6.5a1 1 0 110 2 1 1 0 010-2z"/>
                </svg>
              </a>
              <a 
                href={`https://wa.me/${WHATSAPP_PHONE}`}
                className="drawer-social-link whatsapp" 
                aria-label="WhatsApp" 
                title="WhatsApp"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setIsDrawerOpen(false)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                  <path d="M20.5 3.5A11 11 0 006.4 20.8L3 21l.3-3.4A11 11 0 1020.5 3.5zM12 5.7a6.3 6.3 0 00-6.3 6.3c0 1 .3 2 .7 2.8l-.8 2.8 2.9-.8a6.3 6.3 0 002.7.7 6.3 6.3 0 006.3-6.3A6.3 6.3 0 0012 5.7zm3.6 8.8c-.2.5-1 1-1.3 1.1-.3.1-.7.2-1.1.1-.3 0-.7-.1-1.1-.2-.3-.1-.8-.3-1.7-.8-1-.6-1.6-1.4-1.9-1.7-.2-.3-.5-.6-.6-1 0-.3 0-.6.1-.8.1-.2.3-.5.5-.8.2-.3.4-.4.6-.4.1 0 .3 0 .4.1.2.1.3.3.4.5.1.2.2.3.1.5 0 .1-.1.4-.2.5-.1.1-.2.3-.3.4-.1.1-.2.2-.1.4.1.2.5.9 1.1 1.4.8.7 1.4.9 1.6 1 .2.1.3.1.5 0 .1 0 .3 0 .5-.2.2-.2.7-.6.8-.8.1-.2.3-.2.5-.1.2.1.9.4 1.1.5.1.1.2.2.2.3 0 .2 0 .4-.1.6z"/>
                </svg>
              </a>
              <a 
                href="tel:+919001971755"
                className="drawer-social-link phone" 
                aria-label="Phone" 
                title="Call Us: +91 9001971755"
                onClick={() => setIsDrawerOpen(false)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                  <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                </svg>
              </a>
              </div>
               {/* Built By Section */}
            <div className="drawer-build-name">
              <div className="drawer-build-text">
                <h4>
                  Built By : SSD-TECH-PROG_
                  <a 
                    href="mailto:ssdtechprog@gmail.com" 
                    className="drawer-know-more-link"
                    title="Know more about SSD-TECH-PROG"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                      <polyline points="15 3 21 3 21 9"></polyline>
                      <line x1="10" y1="14" x2="21" y2="3"></line>
                    </svg>
                  </a>
                </h4>
              </div>
            </div>
            </div>
          </div>
        </nav>

        {/* Overlay for mobile drawer */}
        {isDrawerOpen && (
          <div 
            className="drawer-overlay" 
            onClick={() => setIsDrawerOpen(false)}
          ></div>
        )}
      </div>
    </header>
  );
};

export default Header;
